export const productMap = {
  index: {
    title: '상품 관리',
    path: '/products',
    display: true,
  },
  'origin-list': {
    title: '상품관리',
    path: '/products/origin-list',
    display: true,
  },
  'edit-item': {
    title: '상품 수정',
    path: '/products/:shopID/edit-item/:taskID/:saleItemID',
    display: true,
  },
};
